import { useEffect } from "react";

// Injects LocalBusiness JSON-LD so Google can show hours, address & star rating.
export const StructuredData = ({ content, reviews }) => {
  useEffect(() => {
    if (!content) return;
    const data = {
      "@context": "https://schema.org",
      "@type": "Restaurant",
      name: content.business_name,
      image: content.hero_image,
      servesCuisine: "Latin American, Mexican, Street Food",
      priceRange: "$$",
      telephone: content.phone,
      email: content.email,
      url: window.location.origin,
      address: {
        "@type": "PostalAddress",
        streetAddress: "456 Glenbrook Rd",
        addressLocality: "Stamford",
        addressRegion: "CT",
        postalCode: "06906",
        addressCountry: "US",
      },
      geo: {
        "@type": "GeoCoordinates",
        latitude: content.geo_lat,
        longitude: content.geo_lng,
      },
      openingHoursSpecification: [
        {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: ["Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
          opens: "18:00",
          closes: "23:00",
        },
      ],
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: content.rating,
        reviewCount: content.review_count,
        bestRating: "5",
      },
      review: (reviews || []).map((r) => ({
        "@type": "Review",
        author: { "@type": "Person", name: r.author },
        reviewRating: { "@type": "Rating", ratingValue: String(r.rating), bestRating: "5" },
        reviewBody: r.text_en || r.text_es,
      })),
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "ers-jsonld";
    script.text = JSON.stringify(data);
    document.getElementById("ers-jsonld")?.remove();
    document.head.appendChild(script);

    return () => document.getElementById("ers-jsonld")?.remove();
  }, [content, reviews]);

  return null;
};
